import { ThemeProvider } from '@emotion/react'
import { CssBaseline } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { ruRU } from '@mui/x-date-pickers/locales'
import 'dayjs/locale/ru'
import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { Provider } from 'react-redux'
import { store } from '@/store'
import App from './App'
import { theme } from './theme'
import './styles/main.scss'
import { REACT_APP_SENTRY_DSN, SENTRY_TRACES_RATE } from './utils/config'

Sentry.init({
  dsn: REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],

  tracesSampleRate: Number(SENTRY_TRACES_RATE ?? 0.01),
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  //<React.StrictMode>
  <>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="ru"
          localeText={
            ruRU.components.MuiLocalizationProvider.defaultProps.localeText
          }
        >
          <App />
          <CssBaseline />
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  </>
  //</React.StrictMode>
)
